var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPopularSearch = function SvgIconPopularSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon_popular_search_svg__a",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_popular_search_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#929191",
    d: "m2.235 11.77-.703-.703L4.95 7.649a1.8 1.8 0 0 1 1.298-.535q.76-.004 1.298.535l.767.766a.8.8 0 0 0 .594.249.83.83 0 0 0 .593-.249l3.255-3.248h-1.953v-1h3.666v3.666h-1V5.88l-3.265 3.248a1.8 1.8 0 0 1-1.301.536 1.75 1.75 0 0 1-1.295-.53l-.784-.783a.79.79 0 0 0-.585-.237.82.82 0 0 0-.585.237z"
  }))));
};
export default SvgIconPopularSearch;